
import React from 'react';
import { MessageCircle, CheckCircle2 } from 'lucide-react';
import { Subject } from '../types';
import { WHATSAPP_NUMBER } from '../constants';

interface SubjectSectionProps {
  subject: Subject;
}

const SubjectSection: React.FC<SubjectSectionProps> = ({ subject }) => {
  return (
    <div id={subject.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8 hover:shadow-md transition group">
      <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center">
        <span className="w-1.5 h-8 bg-blue-600 rounded-full mr-3"></span>
        {subject.name}
      </h3>
      <p className="text-slate-600 mb-6 leading-relaxed italic">{subject.description}</p>
      
      <div className="mb-8">
        <h4 className="font-semibold text-slate-800 mb-4 flex items-center">
          Sample Chapters:
        </h4>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {subject.chapters.map((chapter, idx) => (
            <li key={idx} className="flex items-center text-sm text-slate-700 bg-gray-50 rounded-lg p-3 border border-gray-100">
              <CheckCircle2 className="h-4 w-4 text-green-500 mr-2 shrink-0" />
              {chapter}
            </li>
          ))}
          <li className="flex items-center text-sm text-blue-600 font-medium italic p-3">
            More chapters coming soon...
          </li>
        </ul>
      </div>

      <div className="border-t border-gray-50 pt-6">
        <a 
          href={`https://wa.me/${WHATSAPP_NUMBER.replace(/\s+/g, '')}?text=I am interested in ${subject.name} notes.`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-green-600 text-white px-8 py-4 rounded-xl font-bold hover:bg-green-700 transition shadow-lg shadow-green-200"
        >
          <MessageCircle className="h-5 w-5" />
          <span>Contact at WhatsApp</span>
        </a>
        <p className="mt-4 text-xs text-slate-400 font-medium">
          Note: Contact us on WhatsApp to get the latest notes and updates.
        </p>
      </div>
    </div>
  );
};

export default SubjectSection;
